import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';

function LoadingIndicator() {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-label">Loading</div>
    </div>
  );
}

function DonorDetail({ allocation, onBack }) {
  //const {pledgeReference, pledgeDate, pledgeAmount} = allocation;
  const [donorDetails, setDonorDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
     if (!allocation) return; // safeguard

  const idToUse = allocation.designationPlanId ?? allocation.allocationId;
  
    axios.get(`${process.env.REACT_APP_API_URL}/DonorDetail?allocationId=${idToUse}`) // Use relative path
      .then((response) => {
        setDonorDetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log('Response error:', error.response.data);
          setError(error.response.data);
        } else if (error.request) {
          console.log('Request error:', error.request);
          setError('No response received from server');
        } else {
          console.log('General error:', error.message);
          setError(error.message);
        }
        setLoading(false);
      });
  }, [allocation]);

  if (loading) return <LoadingIndicator />;
  if (error) return <div>Error: {error.message}</div>;

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      width: 150,valueFormatter: (dateParm) => {
        return moment(dateParm).format('MM/DD/YYYY'); // Fallback to raw value if invalid date
    }
    },
    { field: 'checkNoRef', headerName: 'Allocation Ref', width: 150 },
    { field: 'grossPayment', headerName: 'Gross Payment', width: 150,valueFormatter: (params) => {
      const v = parseFloat(params)
      return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } },
    { field: 'desigFee', headerName: 'Desig Fees', width: 150, valueFormatter: (params) => {
      const v = parseFloat(params)
      return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } },
    { field: 'netPayment', headerName: 'Net Payment', width: 150, valueFormatter: (params) => {
      const v = parseFloat(params)
      return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } },
    //{ field: 'paymentMethod', headerName: 'Payment Method', width: 150 },
  ];

  const rows = donorDetails?.payments?.map((payment, index) => ({
    ...payment,
    id: index
  })) || [];

  return (
    <div>
      <button className="gradient-button" onClick={onBack}>Back</button>
      <h2>Donor Details</h2>
      {donorDetails ? (
        <div>
          <p><strong>Name:</strong> {donorDetails.donorName}</p>
          <p><strong>Address:</strong> {donorDetails.donorAddress}</p>
          <h3>Pledge Details</h3>
          <p><strong>Reference:</strong> {donorDetails.pledgeReference}</p>
          <p><strong>Date:</strong> {moment(donorDetails.pledgeDate).format('MM/DD/YYYY')}</p>
          <p><strong>Pledge Amount:</strong> {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(donorDetails.pledgeAmount)}</p>
          <p><strong>Fullfilled Amount:</strong> {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(donorDetails.pledgeFullfilled)}</p>
          <h3>Payments</h3>
          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
            />
          </div>
        </div>
      ) : (
        <p>Loading donor details...</p>
      )}
    </div>
  );
}

export default DonorDetail;